<template>
  <content-layout class="modal">
    <div class="result">
      <div class="top">
        <span class="order">Счет № {{ order.id }}</span>
        <div class="title">Оплата прошла успешно!</div>
      </div>
      <div class="bottom">
        <div v-if=isMobile class="mobile-content">
          <ul class="order-list">
            <li v-for="(item, index) in order.items" class="order-item" :key="index">
              <table class="order-table">
                <tbody>
                  <tr>
                    <td class="label right">Номер заказа</td>
                    <td class="value">№ {{ index + 1 }}</td>
                  </tr>
                  <tr>
                    <td class="label right">Получатель</td>
                    <td class="value">{{ item.recipient.name }}</td>
                  </tr>
                  <tr>
                    <td class="label right">На e-mail</td>
                    <td class="value">{{ item.recipient.email }}</td>
                  </tr>
                  <tr>
                    <td class="label right">Телефон</td>
                    <td class="value">{{ item.recipient.phone }}</td>
                  </tr>
                  <tr>
                    <td class="label right">Дата отправки</td>
                    <td class="value">{{ item.sendingDate }} в {{ item.sendingHour }}</td>
                  </tr>
                  <tr>
                    <td class="label right">Сумма</td>
                    <td class="value sum">{{ item.amount | costFormat }} руб.</td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
          <div class="total">
            <div class="label right">Итоговая сумма</div>
            <div class="value sum">{{ order.total | costFormat }} руб.</div>
          </div>
        </div>

        <div v-else class="section">
          <table class="order-info">
            <thead class="thead">
              <tr>
                <td class="td">Номер заказа</td>
                <td class="td">Получатель</td>
                <td class="td">На e-mail</td>
                <td class="td">Телефон получателя</td>
                <td class="td">Время отправки</td>
                <td class="td right">Сумма</td>
              </tr>
            </thead>
            <tfoot class="tfoot">
              <tr>
                <td class="td sum-text right" colspan="5">Итоговая сумма</td>
                <td class="td right">{{ order.total | costFormat }} руб.</td>
              </tr>
            </tfoot>
            <tbody class="tbody">
              <tr v-for="(item, index) in order.items" class="tr" :key="`table_${index}`">
                <td class="td">№ {{ index + 1 }}</td>
                <td class="td">{{ item.recipient.name }}</td>
                <td class="td">{{ item.recipient.email }}</td>
                <td class="td">{{ item.recipient.phone }}</td>
                <td class="td">{{ item.sendingDateTime | dateFormat(item.sendingHour) }}</td>
                <td class="td right">{{ item.amount | costFormat }} руб.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="section">
          <p class="reminder">
            <!--Напоминаем, что карты будут действовать только на территории г.&nbsp;{{  city.title }}. -->
            Письмо с подробной информацией по заказу отправлено вам на почту.
          </p>
          <div class="thx">Спасибо за заказ!</div>
        </div>
      </div>
      <router-link :to="{ name: 'Index' }" class="go-back"></router-link>
    </div>
  </content-layout>
</template>

<script>
// import axios from 'axios'

import ContentLayout from '@/components/ContentLayout.vue'
// import { apiUrl } from 'src/config'

export default {
  name: 'virtual-result',
  data () {
    return {
      isMobile: false,
      order: {
        id: '',
        items: [],
        buyer: {}
      },
      city: {}
    }
  },
  beforeCreate () {
    this.order = this.$localStorage.set('result', 'success')
    this.order = this.$localStorage.get('order')
    if (!this.order) {
      this.$router.push({ name: 'ModalError' })
    }
  },
  created () {
    /*
    axios.get(`${apiUrl}/cards`)
    .then(({data}) => {
      this.order = this.$localStorage.get('order')
      this.order.id = this.$localStorage.get('orderId')
      this.city = data.cities.find(city => city.id === this.order.cityId)
      this.$localStorage.remove('order')
      this.$localStorage.remove('orderId')
    })
    */
    this.order = this.$localStorage.get('order')
    this.order.id = this.$localStorage.get('orderId')
    this.$localStorage.remove('order')
    this.$localStorage.remove('orderId')
    window.addEventListener('resize', this.setIsMobile)
    this.setIsMobile()
  },
  methods: {
    setIsMobile () {
      this.isMobile = window.innerWidth < 1024
    }
  },
  beforeDestroy () {
    this.$localStorage.remove('result')
    window.removeEventListener('resize', this.setIsMobile)
  },
  components: {
    ContentLayout: ContentLayout
  }
}
</script>

<style scoped>
  .right {
    text-align: right;
  }
  .result {
    position: relative;
    font: 500 14px/1 Museo, sans-serif;
    width: 970px;
  }
  .top {
    padding: 0 55px 25px;
    border-bottom: 1px solid rgba(139, 139, 139, .5);
  }
  .go-back {
    position: absolute;
    top: 0;
    right: 20px;
    width: 20px;
    height: 20px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
    padding: 5px;
    opacity: .4;
  }
  .go-back:hover {
    opacity: 1;
  }
  .go-back::before,
  .go-back::after {
    content: '';
    display: block;
    background: #000;
    height: 3px;
    width: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transform-origin: center;
  }
  .go-back::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  .order {
    display: inline-block;
    padding: 8px 20px 6px;
    margin-bottom: 20px;
    border-radius: 4px;
    background-color: #bc9665;
    color: #fff;
    text-transform: uppercase;
  }

  .title {
    font: 700 48px/1 Bebas, sans-serif;
  }

  .bottom {
    background-color: #ededed;
    box-shadow: inset 0 4px 12px 0 rgba(0, 0, 0, 0.05);
  }
  .section,
  .order-item {
    position: relative;
    padding: 35px 55px 20px;
  }
  .section::after,
  .order-item::after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background: linear-gradient(to right, #d5d5d4 33%, transparent 33%, transparent 66%, #d5d5d4 66%) repeat-x;
    background-size: 12px 1px;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .section:last-child {
    padding: 25px 33px;
  }
  .section:last-child::after {
    display: none;
  }
  .order-info {
    width: 100%;
    border-collapse: collapse;
  }
  .td {
    padding: 12px;
  }
  .thead {
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }
  .thead .td {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    color: rgba(0, 0, 0, .5);
    padding: 5px 12px 7px;
  }
  .tfoot {
    font-size: 18px;
    font-weight: 700;
  }
  .tfoot .td {
    padding-top: 20px;
  }
  .tbody .tr:first-child .td {
    padding-top: 20px;
  }
  .sum-text {
    text-transform: uppercase;
  }
  .reminder {
    font-size: 13px;
    color: #9d9c9a;
    text-align: center;
    margin: 0 auto 20px auto;
    max-width: 510px;
  }
  .thx {
    font-family: Bebas;
    font-size: 26px;
    font-weight: 700;
    text-align: center;
    text-transform: uppercase;
  }
  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {

    .result {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .top {
      background-color: #f6f6f7;
      border: none;
      padding: 0 20px 25px;
    }
    .go-back {
      box-sizing: content-box;
      background-color: #fff;
      box-shadow: 2.8px 2.8px 14px 0 rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      overflow: hidden;
      padding: 17px;
      position: fixed;
      z-index: 2;
      top: 12px;
      right: 8px;
      opacity: .7;
    }
    .go-back::before,
    .go-back::after {
      width: 20px;
    }
    .order {
      padding: 9px 20px 7px;
      margin-bottom: 15px;
    }
    .title {
      font-size: 36px;
      padding-right: 65px;
    }
    .mobile-content {
      border-bottom: 1px solid rgba(0, 0, 0, .1);
    }
    .order-table {
      width: 100%;
    }
    .label {
      width: 100px;
      font-size: 11px;
      font-weight: 700;
      text-transform: uppercase;
      color: #9d9c9a;
      vertical-align: middle;
    }
    .value {
      padding: 4px 11px;
      font-size: 14px;
      vertical-align: middle;
    }
    .sum {
      font-size: 16px;
    }
    .bottom {
      flex: 1;
    }
    .section {
      padding: 28px 20px 20px;
    }
    .section:last-child {
      padding: 25px 20px;
    }
    .order-list {
      list-style: none;
      margin: 0;
      padding: 0;
    }
    .order-item {
      padding: 20px 20px 20px;
    }
    .order-item:last-child::after {
      display: block;
    }
    .total {
      color: #000;
      font-weight: 700;
      display: flex;
      padding: 15px 20px;
      align-items: center;
      justify-content: flex-start;
    }
    .total .label {
      color: #000;
    }
    .total .sum {
      flex: 1;
      font-size: 18px;
    }
  }
</style>
